export default __webpack_public_path__ + "static/media/lil-sliders.e4d7784b.jpeg";